import React from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import useStyles from 'isomorphic-style-loader/useStyles';

import { useContainerData } from '../../../../shared/public/SlHooks/useContainerData';
import { RepliesOrderType, SlDiscussContext } from '../../global-constants';
import { SlDataService } from '../../services/sl-data.service';
import { Question } from '../Question/Question';
import { Replies } from '../Replies/Replies';
import { RepliesFilter } from '../RepliesFilter/RepliesFilter';
import { ReplyForm } from '../ReplyForm/ReplyForm';
import { ReplyFormSuccessMessage } from '../ReplyFormSuccessMessage/ReplyFormSuccessMessage';
import { RepliesPaginationContainer } from '../RepliesPaginationContainer/RepliesPaginationContainer';
import { Notification } from '../Notification/Notification';
import { HotToday } from '../HotToday/HotToday';
import { RecommendedCourses } from '../RecommendedCourses/RecommendedCourses';
import { CreateEditQuestion } from '../CreateEditQuestion/CreateEditQuestion';
import { QuestionPageType } from '../../global-interface';

import s from './QuestionPage.scss';

export function QuestionPage() {
	useStyles(s);
	const [searchParams] = useSearchParams();
	const currentPageNumber = +searchParams.get('page') || 1;
	const sortType = +searchParams.get('sort') || RepliesOrderType.Vote;
	const { isReplyFormOpen$: isReplyFormOpen } = useContainerData(
		SlDiscussContext,
		SlDataService,
		['isReplyFormOpen$'],
	);

	const { id } = useParams();

	const renderContent = () => {
		if (id === 'New') {
			return <CreateEditQuestion type={QuestionPageType.New} />;
		}
		if (id === 'Edit') {
			return <CreateEditQuestion type={QuestionPageType.Edit} />;
		}

		return (
			<div className="discuss-question-page__question-and-answers">
				<Question />
				<ReplyFormSuccessMessage />
				{isReplyFormOpen && <ReplyForm />}
				<RepliesFilter />
				<Replies
					currentPageNumber={currentPageNumber}
					sortType={sortType}
					key={`${currentPageNumber}_${sortType}`}
				/>
				<RepliesPaginationContainer />
			</div>
		);
	};

	return (
		<>
			<div className="discuss-question-page">
				{renderContent()}
				<div className="discuss-question-page__sidebar">
					<RecommendedCourses />
					<HotToday />
				</div>
			</div>
			<Notification />
		</>
	);
}
